module.exports = __webpack_public_path__ + "assets/img/personal.c91365c6.svg";